module.exports = __webpack_public_path__ + "static/media/approve_icon.6b8034cc.svg";